import { IMenu } from '../models/menu.model';
import { ACCESS_ROLES } from './access-role.constant';

export const MENUS: IMenu[] = [
    {
        name: 'Proposal List',
        link: '/proposal/list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.NO_FINANCE,
        slug: 'proposal-list',
    },
    {
        name: 'Pre Product List',
        link: '/pre-product',
        isHidden: false,
        accessRoles: ACCESS_ROLES.NO_FINANCE,
        slug: 'pre-product',
    },
    {
        name: 'Program Tour List',
        link: '/product/program-tour-list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.PROGRAM_TOUR_LIST_PAGE,
        slug: 'program-tour-list',
    },
    {
        name: 'Leads List',
        link: '/booking/list-v2',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ALL,
        slug: 'booking-list-v2',
    },
    {
        // Pre-booking (ใบ B §13) — แยกจาก Leads/Order ชัด ๆ เพราะใบนี้กันที่นั่งจริง
        name: 'จองยกเลิกฟรี',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.ALL,
        slug: 'prebook',
        collapsedSubMenu: true,
        subMenu: [
            { name: 'แดชบอร์ด', link: '/prebook/dashboard', isHidden: false, accessRoles: ACCESS_ROLES.ALL, slug: 'prebook-dashboard' },
            { name: 'ทำจองยกเลิกฟรี', link: '/prebook/create', isHidden: false, accessRoles: ACCESS_ROLES.ALL, slug: 'prebook-create' },
            { name: 'งานของเซล', link: '/prebook/bookings', isHidden: false, accessRoles: ACCESS_ROLES.ALL, slug: 'prebook-bookings' },
            { name: 'เฝ้ารอบ', link: '/prebook/periods', isHidden: false, accessRoles: ACCESS_ROLES.PREBOOK_ADMIN, slug: 'prebook-periods' },
            { name: 'ตั้งค่า / โหมดซ้อม', link: '/prebook/settings', isHidden: false, accessRoles: ACCESS_ROLES.PREBOOK_ADMIN, slug: 'prebook-settings' },
        ],
    },
    {
        name: 'Order List',
        link: '/order/list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ORDER_CREATE_PAGE,
        slug: 'order-list',
    },
    {
        // ย้ายออกจากกลุ่ม Finance Management (user เคาะ 2 ก.ย. 2569) — หน้า tw-booking ที่การเงินใช้ประจำ
        name: 'Order List (Finance Only)',
        link: '/tw-booking/list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.TW_ORDER_LIST_PAGE,
        slug: 'tw-order-list-finance',
    },
    {
        name: 'Work List',
        link: '/sale-support/work-list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.WORKLIST_GROUP,
        slug: 'work-list',
    },
    {
        name: 'Customer Relation List',
        link: '/customers/list',
        isHidden: false,
        accessRoles: ACCESS_ROLES.CUSTOMER_RELATION_LIST,
        slug: 'customer-relation-list',
    },
    {
        name: 'Commission Report (Old Customer)',
        link: '/commission-report/old-customer',
        isHidden: false,
        accessRoles: ACCESS_ROLES.NO_FINANCE,
        slug: 'commission-report-old-customer',
    },
    {
        name: 'Commission Report (New Customer)',
        link: '/commission-report/new-customer',
        isHidden: false,
        slug: 'commission-report-new-customer',
    },
    {
        name: 'Commission Report',
        link: '/commission-report/list',
        isHidden: false,
        slug: 'commission-report',
    },
    {
        name: 'Telesales Report',
        link: '/report/telesales-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.TELESALES_REPORT,
        slug: 'telesales-report',
    },
    {
        name: 'Cash Outflow Report',
        link: '/cash-outflow-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.CASH_OUTFLOW_REPORT_LIST_PAGE,
        slug: 'cash-outflow-report',
    },
    {
        name: 'Cash Inflow Report',
        link: '/report/cash-inflow-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.CASH_INFLOW_REPORT,
        slug: 'cash-inflow-report',
    },
    {
        name: 'งานการเงิน',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
        slug: 'finance-work',
        subMenu: [
            // เรียงตาม user สั่ง 1 ก.ย. 2569: ค่าใช้จ่าย+ตั้งค่า → Work List v2 → เตือนตามเงิน → ตรวจ Invoice → เมล → กระทบยอด → RV → โอน WS → แจ้งโอน → ใบเสร็จ → PVO
            {
                // หน้าทำงานรวม 4 กล่อง + งานพิมพ์ (เจ้าของเคาะ 28 ก.ย. 2569) — เมนูหน้าเดิมข้างล่างยังเข้าได้ตามปกติ
                name: 'หน้าทำงานรวม',
                link: '/finance-work/work-hub',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
                chip: 'ใหม่',
            },
            {
                name: 'ค่าใช้จ่าย AI',
                link: '/finance-work/llm-usage',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ตั้งค่า API Key (AI)',
                link: '/finance-work/invoice-check-config',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ตั้งค่า Supplier (การเงิน)',
                link: '/finance-work/supplier-config',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                // สเปค work-list-v2 ให้ซ่อนเข้าด้วย URL ตรง — PM ตัดสินใจ 31 ส.ค. 2026 ให้ขึ้นเมนูเลย
                name: 'Work List v2 (งานค้าง)',
                link: '/finance-work/work-list-v2',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'เตือนตามเงินลูกค้า',
                link: '/finance-work/payment-reminder',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ตรวจ Invoice (AI)',
                link: '/finance-work/invoice-check',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ตรวจ Passport (AI)',
                link: '/finance-work/passport-check',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ใบนัดหมาย',
                link: '/finance-work/appointments',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ส่งเมล Supplier',
                link: '/finance-work/supplier-email',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'กระทบยอด Statement',
                link: '/finance-work/statement-matching',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'เตรียมออกใบ RV',
                link: '/finance-work/rv-queue',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'พิมพ์ใบ RV',
                link: '/finance-work/rv-print',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'โอนเงินให้ WS',
                link: '/finance-work/supplier-payment-due',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'แจ้งโอนเงินให้ WS',
                link: '/finance-work/payment-notify',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'ออกใบเสร็จค่าคอม WS',
                link: '/finance-work/receipt-queue',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                // ตั้งชื่อคู่ขนานกับคู่ RV (เตรียมออกใบ/พิมพ์ใบ) — user สั่ง 31 ส.ค. 2569
                name: 'เตรียมออกใบ PVO',
                link: '/finance-work/pvo-prepare',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                name: 'พิมพ์ใบ PVO',
                link: '/finance-work/pvo',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
            {
                // หน้าโหลดไฟล์ล้วน — ไม่มีตัวเลขงานค้างที่เมนู (user เคาะ 9 ก.ย. 2569) · ต้องอยู่ท้ายสุดของหมวด
                name: 'ดาวน์โหลดสำเนาใบเสร็จ',
                link: '/finance-work/receipt-copies',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_GROUP,
            },
        ],
    },
    {
        name: 'Finance Management',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.FINANCE_MANAGEMENT_LEGACY,
        slug: 'finance-management',
        subMenu: [
            {
                name: 'Order List',
                link: '/order-balance/order-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ORDER_LIST_PAGE,
            },
            {
                name: 'Order Matching',
                link: '/order-balance/tw-order-matching-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.TW_ORDER_MATCHING_LIST_PAGE,
            },
            {
                name: 'ข้อมูลการซื้อโปรแกรมทัวร์',
                link: '/order-balance/order-program-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ORDER_PROGRAM_LIST_PAGE,
            },
            {
                name: 'Order Balancing List',
                link: '/order-balance/order-balance-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ORDER_BALANCE_LIST_PAGE,
            },
            {
                name: 'Agency Commission',
                link: '/order-balance/agency-commission',
                isHidden: false,
                accessRoles: ACCESS_ROLES.AGENCY_COMMISSION_PAGE,
            },
            {
                name: 'Order Voucher List',
                link: '/order-balance/voucher-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ORDER_VOUCHER_LIST_PAGE,
            },
            {
                name: 'Seller Voucher',
                link: '/order-balance/seller-voucher',
                isHidden: false,
                accessRoles: ACCESS_ROLES.SELLER_VOUCHER_PAGE,
            },
            {
                name: 'Fee List',
                link: '/order-balance/fee-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.FEE_LIST_PAGE,
            },
            {
                name: 'Tourwow Fee',
                link: '/order-balance/tourwow-fee',
                isHidden: false,
                accessRoles: ACCESS_ROLES.TOURWOW_FEE_PAGE,
            },
        ],
    },
    {
        name: 'Product Management',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.NO_FINANCE,
        slug: 'product-management',
        subMenu: [
            {
                name: 'Keyword List',
                link: '/product/keyword-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.KEYWORD_LIST_PAGE,
            },
            {
                name: 'Period Management',
                link: '/product/period-management-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.PERIOD_MANAGEMENT_LIST_PAGE,
            },
            {
                name: 'Product List',
                link: '/product/product-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ALL,
            },
        ],
    },
    {
        name: 'R&D For IT',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.ALL,
        slug: 'research-and-development-for-id',
        subMenu: [
            {
                name: 'Report plus',
                link: '/report/pre-product-file-report',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ALL,
                slug: 'pre-product-file-reports',
            },
            {
                name: 'Booking List',
                link: '/booking/list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'booking-list',
            },
            {
                name: 'Order List V2',
                link: '/order/list-v2',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'order-list-v2',
            },
            {
                name: 'Sitemap List',
                link: '/sitemap/sitemap-list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'sitemap-list',
            },
            {
                name: 'Sales Funnel Report',
                link: '/report/sales-funnel',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'sales-funnel-report',
            },
            {
                name: 'Order Management',
                link: '/order/management',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'order-management',
            },
            {
                name: 'AI Management',
                link: '/ai-management',
                isHidden: false,
                accessRoles: ACCESS_ROLES.RD_FOR_IT,
                slug: 'ai-management',
            },
            {
                name: 'AI Setting (Add Product)',
                link: '/ai-setting',
                isHidden: false,
                slug: 'ai-setting',
                accessRoles: ACCESS_ROLES.AI_SETTING,
            },
            {
                name: 'Messaging api (Add Product)',
                link: '/messaging-api',
                isHidden: false,
                slug: 'messaging-api',
                accessRoles: ACCESS_ROLES.MESSAGING_API,
            },
            {
                name: 'Customer Management',
                link: '/customer-management',
                isHidden: false,
                slug: 'customer-management',
                accessRoles: ACCESS_ROLES.CUSTOMER_MANAGEMENT,
            },
            {
                name: 'Customer Matching List',
                link: '/customers/matching-list',
                isHidden: false,
                slug: 'customer-matching-list',
                accessRoles: ACCESS_ROLES.ALL,
            },
        ],
    },
    {
        name: 'Page Config',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.PAGE_CONFIG,
        slug: 'page-config',
        subMenu: [
            {
                name: 'Promotion List',
                link: '/config/promotion/list',
                isHidden: false,
                accessRoles: ACCESS_ROLES.ALL,
                slug: 'promotion-list',
            },
        ],
    },
    {
        name: 'Count Leads Report',
        link: '/report/count-leads-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.COUNT_LEADS_REPORT,
        slug: 'count-leads',
    },
    {
        name: 'Orders Count Report',
        link: '/report/orders-count-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ORDERS_COUNT_REPORT,
        slug: 'orders-count',
    },
    {
        name: 'Orders Report for Wholesale Payment',
        link: '/report/orders-report-for-wholesale-payment',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ORDER_REPORT_FOR_WHOLESALE_PAYMENT,
        slug: 'orders-report-for-wholesale-payment',
    },
    {
        name: 'Daily Win Report',
        link: '/report/daily-win-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ALL,
        slug: 'daily-win-report',
    },
    {
        name: 'Tracking Leads Report',
        link: '/report/tracking-leads-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.TRACKING_LEADS_REPORT,
        slug: 'tracking-leads-report',
    },
    {
        name: 'คะแนนประเมิน CRM',
        link: '/report/survey-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.SURVEY_REPORT,
        slug: 'survey-report',
    },
    {
        name: 'OTP Login Report',
        link: '/report/otp-login-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.OTP_LOGIN_REPORT,
        slug: 'otp-login-report',
    },

    {
        name: 'Pipeline Management',
        link: null,
        isHidden: false,
        accessRoles: ACCESS_ROLES.PIPELINE_MANAGEMENT_GROUP,
        slug: 'pipeline-management',
        subMenu: [
            {
                name: 'Create Pipeline',
                link: '/pipeline/create',
                isHidden: false,
            },
            {
                name: 'Pipeline List',
                link: '/pipeline/list',
                isHidden: false,
            },
        ],
    },
    {
        name: 'Crm Kpi Report',
        link: '/report/crm-kpi-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.CRM_KPI_REPORT,
        slug: 'crm-kpi-report',
    },
    {
        name: 'Tracking Report',
        link: '/report/tracking-report',
        isHidden: false,
        accessRoles: ACCESS_ROLES.TRACKING_REPORT,
        slug: 'tracking-eport',
    },
    {
        name: 'Logout',
        link: '/logout',
        isHidden: false,
        accessRoles: ACCESS_ROLES.ALL,
        slug: 'logut',
    },
];
